module.exports = __webpack_public_path__ + "img/wen.233a89e2.png";